import { Box, Typography } from '@mui/material';

export const SummaryBoxContainer: React.FC = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#e9edf1',
        padding: 4,
        borderRadius: 8,
      }}
    >
      <Typography variant="h6" color="primary">
        Hinnaston tiedot
      </Typography>
      {children}
    </Box>
  );
};
